/* Outputs the montly amount for Annuity Loans */
export const annuityLoan = (
    interestRate: number | undefined,
    adminFee: number | undefined,
    pledgeFee: number | undefined,
    invoiceFee: number | undefined,
    amount: number | undefined,
    months: number | undefined,
): number | undefined => {
    if (
        Number.isNaN(interestRate) ||
        Number.isNaN(adminFee) ||
        Number.isNaN(pledgeFee) ||
        Number.isNaN(invoiceFee) ||
        Number.isNaN(amount) ||
        Number.isNaN(months)
    ) {
        return undefined;
    }

    const k = 1 / (1 + Number(interestRate) / (12 * 100));
    const mainBasis = Number(amount) + Number(adminFee) + Number(pledgeFee);

    const monthlyCost = (mainBasis * (1 - k)) / (k - k ** (Number(months) + 1)) + Number(invoiceFee);
    if (!Number.isNaN(monthlyCost)) return monthlyCost;
    return undefined;
};

export default { annuityLoan };
